import type {
  InquiryDataSource,
  ProductInquiryRequest,
} from '~/api/data-source/inquiry';
import { inquiryDataSource } from '~/api/data-source/inquiry';
import type { ProductInquiry, ProductInquiryPage } from '~/api/model';
import {
  parseModel,
  productInquiryPageSchema,
  productInquirySchema,
} from '~/api/model';

export interface InquiryRepository {
  // Query
  getMyInquiries(params?: {
    lastInquiryId?: number;
    size?: number;
  }): Promise<ProductInquiryPage>;
  getMyInquiryCount(): Promise<number>;

  // Mutation
  editInquiry(
    inquiryId: number,
    data: ProductInquiryRequest,
  ): Promise<ProductInquiry>;
  deleteInquiry(inquiryId: number): Promise<ProductInquiry>;
}

export class InquiryRepositoryImpl implements InquiryRepository {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    private readonly dataSource: InquiryDataSource = inquiryDataSource,
  ) {}

  async getMyInquiries(params?: { lastInquiryId?: number; size?: number }) {
    const response = await this.dataSource.getMyInquiries(params);
    return parseModel(productInquiryPageSchema, response, 'ProductInquiryPage');
  }

  async getMyInquiryCount() {
    return this.dataSource.getMyInquiryCount();
  }

  async editInquiry(inquiryId: number, data: ProductInquiryRequest) {
    const response = await this.dataSource.editInquiry(inquiryId, data);
    return parseModel(productInquirySchema, response, 'ProductInquiry');
  }

  async deleteInquiry(inquiryId: number) {
    const response = await this.dataSource.deleteInquiry(inquiryId);
    return parseModel(productInquirySchema, response, 'ProductInquiry');
  }
}

export const inquiryRepository = new InquiryRepositoryImpl();
